export function studentWorkJson(
  contentId,
  modeName,
  currentScore,
  minutes,
  seconds,
  attempts,
  controlsList,
  priorityActive,
  sketchPadData,
  textAreaData,
  savedAudioURL
) {
  let workData = {}
  workData = {
    ContentID: contentId,
    ModeName: modeName,
    Score: currentScore,
    TimeTaken: minutes + ':' + minutes,
    Attempts: attempts,
    listControls: controlsList,
    TotalScore: currentScore,
    TimeTakenOverall: minutes + ':' + seconds,
    AttemptsOverall: attempts,
    priorityCount: priorityActive,
    Platform: 'Web',
    sketchPadData: sketchPadData,
    textAreaData: textAreaData,
    RecordedUrl: savedAudioURL
  }
  return workData
}

export function saveCurrentPageDataInLocal(
  completed,
  contentId,
  modeName,
  currentScore,
  minutes,
  seconds,
  attempts,
  controlsList,
  priorityActive,
  inkData,
  resetData,
  sketchPadData,
  textAreaData,
  savedAudioURL
) {
  let workData = studentWorkJson(
    contentId,
    modeName,
    currentScore,
    minutes,
    seconds,
    attempts,
    controlsList,
    priorityActive,
    sketchPadData,
    textAreaData,
    savedAudioURL
  )
  let studentActivityData = {
    ContentID: contentId,
    Attempts: attempts,
    Work: JSON.stringify([workData]),
    Ink: JSON.stringify(inkData),
    Reset: 0,
    TotalTries: 1,
    WorkJson: JSON.stringify([workData]),
    InkJson: JSON.stringify(inkData)
  }
  return studentActivityData
}

export function studentDataToApi(
  currentLessonUnitDistId,
  user,
  activityDataFromParent,
  completed,
  currentScore,
  attempts,
  workData,
  inkData,
  spentTime,
  resetData,
  submitDate,
  average,
  totalReset,
  allPagesData
) {
  let studentActivityData = JSON.stringify({
    LessonUnitDistID: currentLessonUnitDistId,
    StudentID: user.LoginID,
    DomainID: user.DomainID,
    ContentID: activityDataFromParent.ContentID,
    Completed: completed,
    TotalPoints: currentScore,
    Attempts: attempts,
    Work: workData,
    Ink: inkData,
    SpentTime: spentTime,
    Reset: resetData,
    SubmitDate: submitDate,
    CumulativeAttempts: attempts,
    CumulativeTimeTaken: spentTime,
    CumulativeAverage: average,
    TotalTries: totalReset + 1,
    OtherActivity: allPagesData
  })
  return studentActivityData
}
